export default "__VITE_ASSET__DRSRMIN___"